<template>
	<div id="layout-header">
		<div class="nav-time">
			<div>{{ nowMonthDay }}<span></span>{{ nowWeek }}</div>
			<div>{{ nowTime }}</div>
		</div>
		<ul>
			<!-- style="cursor: not-allowed"-->
			<router-link
				to="/realtime"
				tag="li"
				:class="{
					layoutNavAction: $route.matched[1].meta.title.includes('实时数据'),
				}"
				>实时数据</router-link
			>
			<router-link
				v-show="isShowOperator"
				to="/operator-data"
				tag="li"
				:class="{
					layoutNavAction: $route.matched[1].meta.title.includes('运营商'),
				}"
				>运营商数据</router-link
			>
			<router-link
				to="/ranks"
				tag="li"
				:class="{
					layoutNavAction: $route.matched[1].meta.title.includes('排行榜'),
				}"
				>排行榜</router-link
			>
			<!-- style="cursor: not-allowed"  -->
			<router-link
				to="/map"
				tag="li"
				:class="{ layoutNavAction: $route.matched[1].meta.title === '地图' }"
				>地图</router-link
			>
		</ul>
		<img src="@/assets/image/layout/logo.svg" />
		<!-- ||$route.meta.title==='信号热力图' -->
		<div
			class="head-select"
			:class="{ noCity: $route.meta.title === '网速地图' }"
		>
			<!-- &&$route.meta.title!=='信号热力图' -->
			<select-city
				v-if="
					$route.meta.title !== '网速地图' &&
					$route.meta.title !== '找回密码' &&
					$route.meta.title !== '个人中心' &&
					$route.meta.title !== '注销账号' &&
					$route.meta.title !== '会员购买'
				"
			/>
			<select-time
				v-if="
					!$route.meta.title.includes('实时数据') &&
					$route.meta.title !== '找回密码' &&
					$route.meta.title !== '个人中心' &&
					$route.meta.title !== '注销账号' &&
					$route.meta.title !== '会员购买'
				"
			/>
		</div>
		<div
			class="login"
			:class="{ isLogin }"
			@click.stop="!isLogin && openLogin()"
		>
			<div class="login-list">
				<div class="login-item" @click.stop="jumpTo()">账号管理</div>
				<div class="login-item" @click.stop="quit">退出登录</div>
			</div>
			<div class="member-icon" :class="{ active: is_member }"></div>
		</div>
	</div>
</template>
<script>
	import SelectCity from '@/components/layout/SelectCity.vue'
	import SelectTime from '@/components/layout/SelectTime.vue'
	import { mapState } from 'vuex'
	import { loginOut } from '@/api/login'
	import jwtDecode from 'jwt-decode'
	import { storage } from '@/utils/hooks/index'
  import { permissionList } from '@/dictionary/index'
	// import login from '@/store/modules/login'
	export default {
		data() {
			return {
				date: new Date(),
				timer: null,
				isLogin: false,
				isShowOperator: false, //是否显示运营商
			}
		},
		created() {
			if (
				this.$store.getters['login/getIsLogin'] &&
				storage.get('access_token') &&
				storage.get('token_type')
			) {
				//已经登录了
				try {
					const infor = jwtDecode(this.$store.getters['login/getToken'])
					if (infor.roles && infor.roles[1] && infor.roles[1].roleId === 2) {
						//说明了是可以看
						this.isShowOperator = true
					}
				} catch (error) {}
			}
		},
		components: {
			SelectCity,
			SelectTime,
		},
		computed: {
			nowWeek() {
				let weekMap = ['日', '一', '二', '三', '四', '五', '六']
				return `周` + weekMap[this.date.getDay()]
			},
			nowMonthDay() {
				let month = (this.date.getMonth() + 1).toString().padStart(2, '0')
				let day = this.date.getDate().toString().padStart(2, '0')
				return `${month}月${day}日`
			},
			nowTime() {
				let hour = this.date.getHours().toString().padStart(2, '0')
				let minute = this.date.getMinutes().toString().padStart(2, '0')
				let second = this.date.getSeconds().toString().padStart(2, '0')
				return `${hour}:${minute}:${second}`
			},
			...mapState('login', ['is_login', 'is_member', 'access_token']),
		},
		methods: {
			getNewDate() {
				this.timer = setInterval(() => {
					this.date = new Date()
				}, 100)
			},
			openLogin() {
				this.$store.commit('login/setValue', [this.$route.path, 'backUrl'])
				this.$loginDialog.open()
			},
			//跳转到对应的链接
			jumpTo() {
				this.$router.push({ path: '/personal-center' })
			},
			quit() {
				loginOut({ apiVersion: 'v1' })
					.then((res) => {
						console.log(res)
					})
					.catch((err) => {
						console.log(err)
					})
					.finally(() => {
						this.$store.commit('login/delValue', 'access_token')
						this.$store.commit('login/delValue', 'refresh_token')
						this.$store.commit('login/delValue', 'token_type')
						this.$store.commit('login/delValue', 'is_login')
						this.$store.commit('login/delValue', 'is_member')
						this.$store.commit('login/delValue', 'effect_end_date')
						this.$store.commit('login/delValue', 'userInfor')
						this.$store.commit('login/delValue', 'backUrl')
						let currentRoute = this.$router.path
						const whiteList = [
							'/',
							'/realtime',
							'/operators',
							'/ranks',
							'/map/speed',
							'/map/signal',
							'/back-password',
						]
						if (whiteList.includes(currentRoute)) {
							location.href = location.href
						} else {
							location.href = '/'
						}
					})
			},
		},
		watch: {
			$route() {
				//console.log(this.$route.matched[1].meta.title)
			},
			is_login: {
				handler(newval) {
					if (newval) {
						this.isLogin = true
					} else {
					}
				},
				deep: true,
			},
			is_member: {
				handler(newval, oldVal) {
					console.log(newval, oldVal)
					if (newval) {
					} else {
					}
				},
				deep: true,
				immediate: true,
			},
			access_token: {
				handler(newval, oldVal) {
					if (
						this.$store.getters['login/getIsLogin'] &&
						storage.get('access_token') &&
						storage.get('token_type')
					) {
						//已经登录了
						try {
							const infor = jwtDecode(this.$store.getters['login/getToken'])
							if (
								infor.roles &&
								infor.roles[1] &&
								infor.roles[1].roleId === 2
							) {
								//说明了是可以看
								this.isShowOperator = true
								//说明了是可以看
								if (permissionList && permissionList.length) {
									permissionList.forEach((item) => {
										this.$router.addRoute('Layout', item)
									})
								}
							} else {
                this.isShowOperator = false
              }
						} catch (error) {}
					} else {
            this.isShowOperator = false
          }
				},
				deep: true,
				immediate: true,
			},
		},
		mounted() {
			this.getNewDate()
			this.isLogin = this.$store.getters['login/getIsLogin']
		},
		beforeDestroy() {
			clearTimeout(this.timer)
		},
	}
</script>
<style lang="less">
	#layout-header {
		width: 100%;
		height: 1.12rem;
		background: url('@/assets/image/layout/nav_background_image.png') no-repeat;
		background-size: 100% 1.21rem;
		background-position: 0 -0.09rem;
		position: relative;
		.nav-time {
			width: 1.34rem;
			height: 0.5rem;
			font-weight: 500;
			position: absolute;
			top: 0.1275rem;
			left: 0.18rem;
			color: #00d2fa;
			line-height: 0.19rem;
			padding: 5px 6px;
			box-sizing: border-box;
			div:nth-child(1) {
				font-size: 12px;
				line-height: 12px;
				transform: scale(0.75);
				margin-left: -12.5%;
				span {
					display: inline-block;
					width: 0.15rem;
				}
			}
			div:nth-child(2) {
				margin-top: 0.04rem;
				font-size: 13px;
				line-height: 19px;
			}
		}
		ul {
			li {
				cursor: pointer;
				position: absolute;
				top: 0.2rem;
				font-size: 0.2rem;
				font-weight: bold;
				opacity: 60%;
				color: #ffffff;
				height: 0.4rem;
				line-height: 0.4rem;
				letter-spacing: 0.02rem;
				&::after {
					// width: 0.87rem;
					width: 100%;
					height: 0.03rem;
					background: rgba(255, 255, 255, 1);
					border-radius: 0.03rem;
					display: block;
					content: '';
					position: absolute;
					// left: calc(50% - 0.25rem);
					// bottom: -0.09rem;
					left: 50%;
					transform: translateX(-50%);
					box-shadow: 0px 0 0.1rem #7af1ff;
					display: none;
				}
			}
			li:nth-child(1) {
				left: 3.78rem;
			}
			li:nth-child(2) {
				left: 5.46rem;
				// &::after {
				//   margin-left: 0.12rem;
				// }
			}
			li:nth-child(3) {
				left: 12.64rem;
				// &::after {
				//   margin-left: 0.11rem;
				// }
			}
			li:nth-child(4) {
				left: 14.32rem;
				// &::after {
				//   margin-left: -0.215rem;
				// }
			}
			.layoutNavAction {
				opacity: 100%;
				// border-bottom: 0.04rem solid #FFFFFF
				text-shadow: 0 0 0.1rem #7af1ff;
				// box-shadow: 0 0 0.1rem #7AF1FF
				&::after {
					display: block;
					// align:center;
				}
			}
		}
		img {
			position: absolute;
			top: 0.14rem;
			left: 7.52rem;
			width: 4.16rem;
			height: 0.7rem;
		}
		.head-select {
			width: 3.4rem;
			height: 0.5rem;
			position: absolute;
			top: 0.2rem;
			left: 14.9rem;
			z-index: 11;
			&.noCity {
				& > div {
					float: left;
					margin-left: 50px;
				}
			}
			& > div {
				float: right;
			}
			&.left > div {
				float: left;
			}
		}
		.login {
			position: absolute;
			top: 0.2rem;
			right: 18px;
			width: 32px;
			height: 32px;
			background: url(@/assets/image/icon/login.png);
			background-size: 100%;
			z-index: 999;
			cursor: pointer;
			&.isLogin:hover {
				.login-list {
					opacity: 1;
					visibility: visible;
					transition: opacity 0.3s;
					animation: none;
				}
			}
			.login-list {
				opacity: 0;
				display: block;
				visibility: hidden;
				transition: opacity 0.3s 0.3s, visibility 0.4s;
				animation: control-pointer 0.6s;
				height: 59px;
				width: 72px;
				padding: 9px 0;
				padding-bottom: 0;
				box-sizing: border-box;
				position: absolute;
				top: 44px;
				right: -10px;
				background: url(@/assets/image/icon/login-backGrpund.png);
				background-size: 100%;
				.login-item {
					width: 100%;
					text-align: center;
					margin-bottom: 9px;
					height: 16px;
					line-height: 16px;
					font-size: 11px;
					color: #ffffff;
					cursor: pointer;
				}
			}
			.member-icon {
				width: 16px;
				height: 16px;
				background: url(@/assets/image/icon/noMember.png) no-repeat center;
				background-size: 100%;
				position: absolute;
				left: -5px;
				top: 0.24rem;
				&.active {
					background: url(@/assets/image/icon/isMember.png) no-repeat center;
					background-size: 100%;
				}
			}
		}
	}

	@media screen and (min-width: 900px) and (max-width: 1500px) {
		#layout-header {
			.nav-time {
				width: 1.34rem;
				position: absolute;
				top: 15px;
				left: 0.18rem;
				color: #00d2fa;
				padding: 5px 6px;
				box-sizing: border-box;
				height: auto;
				div:nth-child(1) {
					font-size: 12px;
					line-height: 12px;
					transform: scale(0.75);
					margin-left: -12.5%;
					span {
						display: inline-block;
						width: 0.15rem;
					}
				}
				div:nth-child(2) {
					margin-top: 6px;
					font-size: 13px;
					line-height: 19px;
				}
			}
			ul {
				li {
					color: #ffffff;
					height: 0.4rem;
					line-height: 0.4rem;
					letter-spacing: 0.02rem;
					&::after {
						left: 50%;
						transform: translateX(-50%);
						margin-left: 0;
					}
				}
				li:nth-child(1) {
					left: 18%;
				}
				li:nth-child(2) {
					left: 26%;
					&::after {
						margin-left: 0;
					}
				}
				li:nth-child(3) {
					left: 64.5%;
					&::after {
						margin-left: 0;
					}
				}
				li:nth-child(4) {
					left: 70%;
					&::after {
						margin-left: 0;
					}
				}
			}
			img {
				position: absolute;
				top: 0.14rem;
				left: 35%;
				width: 4.16rem;
				height: 0.7rem;
			}
			.head-select {
				right: 70px;
				left: auto;
				.select-city {
					.select-city-modal {
						.select-city-content {
							left: calc(50% - 4.2rem);
						}
					}
				}
			}

			.el-date-editor.el-input,
			.el-date-editor.el-input__inner {
				width: 100%;
			}
		}
	}

	@keyframes control-pointer {
		0%,
		49.9999% {
			pointer-events: auto;
		}
		50%,
		100% {
			pointer-events: none;
		}
	}
</style>
